<template>
  <b-modal centered size="lg"
    id="testSettings" hide-footer title="Настройки теста"
    @show="onShow"
  >
    <div class="testSettings p-2">
      <div class="row">
        <b-col sm="4" class="p-1 mb-2">
          <label>Название теста:</label>
        </b-col>
        <b-col sm="8">
          <b-form-input v-model="testTitle" type="text"></b-form-input>
          <span class="markInput__markError m-1 mb-1" v-show="testTitle.length <= 0">
            Укажите название
          </span>
        </b-col>
      </div>
      <div class="row">
        <b-col sm="4" class="p-1 mb-2">
          <label>Открытие доступа:</label>
        </b-col>
        <b-col sm="8">
          <VueCtkDateTimePicker
            color="#0078c1"
            button-color="#0078c1"
            format="YYYY-MM-DD HH:mm"
            label="Выберите дату и время"
            button-now-translation="Сейчас"
            v-model="openning"
          />
          <span class="markInput__markError m-1 mb-1" v-show="!openning">
            Укажите дату и время
          </span>
        </b-col>
      </div>
      <div class="row">
        <b-col sm="4" class="p-1 mb-2">
          <label>
            <b-form-checkbox v-model="isClosure">Закрытие доступа:</b-form-checkbox>
          </label>
        </b-col>
        <b-col sm="8">
          <VueCtkDateTimePicker
            color="#0078c1"
            button-color="#0078c1"
            format="YYYY-MM-DD HH:mm"
            label="Выберите дату и время"
            button-now-translation="Сейчас"
            :readonly="!isClosure" v-model="closure"
          />
          <span
            class="markInput__markError m-1 mb-1"
            v-show="isClosure && (!closure || !isClosureCorrect)"
          >
            {{ isClosureCorrect ? 'Укажите дату и время' : 'Закрытие должно быть позже открытия' }}
          </span>
        </b-col>
      </div>
      <div class="row">
        <b-col sm="5" class="p-1 mb-2">
          <label>
            <b-form-checkbox
              v-model="isDuration"
            >Ограничение по времени(мин):</b-form-checkbox>
          </label>
        </b-col>
        <b-col sm="7">
          <b-form-input :readonly="!isDuration" v-model="timeLimit" type="number" min="1"></b-form-input>
          <span
            class="markInput__markError"
            v-show="isDuration && Number(timeLimit) <= 0"
          >
            Укажите время
          </span>
        </b-col>
      </div>
      <div class="row p-1 totalQuestions">
        <p>
          Количество вопросов в тесте: {{ numOfQuestions }}
          <br>
        </p>
      </div>
      <div class="row p-1 markCriteria">
        <p>
          Критерии оценки <span>(количество баллов для получения оценки)</span>
        </p>
      </div>
      <div class="row">
        <span class="ml-1 p-2">
          5 - <input v-model="marks['5']" class="markInput" type="number" min="3" :max="numOfQuestions"> <br>
          <span class="markInput__markError"
            v-show="marks !== null ? marks['5'] > numOfQuestions : false"
          >
            Количество баллов задано неверно
          </span>
          <span class="markInput__markError"
            v-show="marks !== null ? Number(marks['5']) == 0 : false"
          >
            Укажите количество баллов
          </span>
          <span class="markInput__markError"
            v-show="marks !== null ? Number(marks['5']) < 0 : false"
          >
            Количество баллов задано неверно
          </span>
        </span>
      </div>
      <div class="row">
        <span class="ml-1 p-2">
          4 - <input v-model="marks['4']" class="markInput" type="number" min="2" :max="Number(marks['5'] - 1)"> <br>
          <span class="markInput__markError" v-show="marks !== null ? (Number(marks['4']) != 0
                        && (Number(marks['4']) < 0 || (Number(marks['4']) >= Number(marks['5'])
                        || Number(marks['4'] > Number(numOfQuestions))))) : false">
            Количество баллов задано неверно
          </span>
          <span class="markInput__markError"
            v-show="marks !== null ? Number(marks['4']) == 0 : false"
          >
            Укажите количество баллов
          </span>
        </span>
      </div>
      <div class="row">
        <span class="ml-1 p-2">
          3 - <input v-model="marks['3']" class="markInput" type="number" min="1" :max="Number(marks['4'] - 1)"> <br>
          <span class="markInput__markError" v-show="marks !== null ? (Number(marks['3']) != 0
                        && (Number(marks['3']) < 0 || (Number(marks['3']) >= Number(marks['5'])
                        || Number(marks['3']) >= Number(marks['4'])
                        || Number(marks['3']) > Number(numOfQuestions)))) : false">
            Количество баллов задано неверно
          </span>
          <span class="markInput__markError"
            v-show="marks !== null ? Number(marks['3']) == 0 : false"
          >
            Укажите количество баллов
          </span>
        </span>
      </div>
      <div class="row testSettings__footer mt-2">
        <b-button
          variant="primary"
          class="testSettings__footer__button mr-4"
          @click="updateTestSettings"
          :disabled="!areMarksRight || !isTimeRight || !isClosureCorrect
                      || !isOpenningCorrect"
        >
          Сохранить изменения
        </b-button>
        <b-button
          @click="declineSettingsChange"
          variant="outline-primary"
          class="testSettings__footer__button"
        >
          Отменить изменения
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>

import moment from 'moment'

import { mapActions, mapGetters } from 'vuex'

import TestAPI from '@/api/test'

export default {
  name: 'ModalTestSettings',
  components: {
  },
  props: {
    numOfQuestions: {
      type: Number,
      default() {
        return 0
      }
    },
    title: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      timeLimit: '',
      isDuration: false,
      isClosure: false,
      closure: null,
      openning: null,
      testTitle: '',
      marks: {
        5: '',
        4: '',
        3: ''
      },
      edited: true
    }
  },
  computed: {
    ...mapGetters({
      testSettings: 'test/getTest'
    }),
    areMarksRight() {
      return (this.marks !== null && this.numOfQuestions) ? Number(this.marks['5']) <= Number(this.numOfQuestions)
              && (Number(this.marks['4']) < Number(this.numOfQuestions) && Number(this.marks['4']) < Number(this.marks['5']))
              && (Number(this.marks['3']) < Number(this.numOfQuestions) && Number(this.marks['3']) < Number(this.marks['5'])
              && Number(this.marks['3']) < Number(this.marks['4']))
              && Number(this.marks['5'] > 0) && Number(this.marks['4'] > 0)
                && Number(this.marks['3'] > 0) : this.numOfQuestions > 4
    },
    isTimeRight() {
      return this.isDuration ? (Number(this.timeLimit) > 0) : true
    },
    isClosureCorrect() {
      const d1 = moment(this.closure)
      const d2 = moment(this.openning)
      return this.isClosure ? moment(d1).isAfter(d2) : true
    },
    isOpenningCorrect() {
      return this.openning
    }
  },
  watch: {
    isDuration() {
      this.timeLimit = ''
    },
    isClosure() {
      this.closure = null
    }
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts',
      fetchTest: 'test/fetchTest',
      fetchCourseContent: 'education/fetchCourseContent'
    }),
    declineSettingsChange() {
      this.$emit('closeSettings')
    },
    updateTestSettings() {
      const testSettings = {
        title: this.testTitle,
        accessStart: moment(this.openning),
        accessEnd: moment(this.closure),
        marksMap: this.marks
      }
      if (this.isDuration) {
        testSettings.timeLimit = Number(this.timeLimit)
      }
      TestAPI.updateTestSettings(this.$route.params.courseBookId, this.testSettings.id,
        testSettings)
        .then(() => {
          this.fetchCourseContent({ id: this.$route.params.courseBookId })
          this.fetchTest({
            courseId: this.$route.params.courseBookId,
            testId: this.$route.params.sectionId
          }).then(() => {
            this.declineSettingsChange()
          })
        })
    },
    reset() {
      this.isDuration = false
      this.isClosure = false
      this.closure = null
      this.openning = null
      this.testTitle = ''
      this.marks = null
    },
    onShow() {
      this.reset()
      if (this.testSettings) {
        this.isDuration = !!this.testSettings.timeLimit
        if (this.isDuration) {
          setTimeout(() => {
            this.timeLimit = this.testSettings.timeLimit
          }, 100)
        }
        this.isClosure = !!this.testSettings.accessEnd
        if (this.testSettings.accessStart) {
          const d1 = new Date(this.testSettings.accessStart)
          this.openning = `${d1.getFullYear()}-${(d1.getMonth() + 1) < 10 ? `0${(d1.getMonth() + 1)}` : (d1.getMonth() + 1)}-${d1.getDate() < 10 ? `0${d1.getDate()}` : d1.getDate()}T${d1.getHours() < 10 ? `0${d1.getHours()}` : d1.getHours()}:${d1.getMinutes() < 10 ? `0${d1.getMinutes()}` : d1.getMinutes()}`
        }
        if (this.isClosure) {
          const d2 = new Date(this.testSettings.accessEnd)
          setTimeout(() => {
            this.closure = `${d2.getFullYear()}-${(d2.getMonth() + 1) < 10 ? `0${(d2.getMonth() + 1)}` : (d2.getMonth() + 1)}-${d2.getDate() < 10 ? `0${d2.getDate()}` : d2.getDate()}T${d2.getHours() < 10 ? `0${d2.getHours()}` : d2.getHours()}:${d2.getMinutes() < 10 ? `0${d2.getMinutes()}` : d2.getMinutes()}`
          }, 100)
        }
        this.testTitle = this.testSettings.title
        if (this.testSettings.marksMap !== null) {
          this.marks = {
            5: this.testSettings.marksMap['5'],
            4: this.testSettings.marksMap['4'],
            3: this.testSettings.marksMap['3']
          }
        } else {
          this.marks = {
            5: '',
            4: '',
            3: ''
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance:textfield;
}

.testSettings {

  font-size: 1.2em;

  .markCriteria {
    font-weight: 600;

    span {
      font-weight: 400;
      font-size: 0.8em;
    }
  }

  .markInput {
    text-align: right;

    &__markError {
      color: red;
      font-size: 0.8em;
    }
  }

  &__footer {

    &__button {
      width: 48%;
    }
  }
}

.markInput {
  width: 40px;
}

p {
  margin-bottom: 0;
}

.totalQuestions {
  font-size: 1.3em;
  font-weight: 600;
}

</style>
